import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import OrganizedUnitConfigurationModalPage from '../../../containers/masters/OrganizedUnitConfiguration/OrganizedUnitConfigurationModalPage'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class OrganizedUnitConfigurationMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        organizedUnitId: null,
        configParameterId: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchOrganizedUnitsAll()
    this.props.actions.fetchConfigParameterAll()
    this.props.actions.fetchOrganizedUnitConfigurationList()
  }

  componentDidUpdate () {
    if (this.props.ouIdFromMaster != null) {
      const form = {
        filters: {
          organizedUnitId: this.props.ouIdFromMaster
        }
      }
      this.props.initialize(form)
      this.handleorganizedUnitComboChange(this.props.ouIdFromMaster)
      this.props.actions.setChangeTabFromConfMaster(null, false)
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchOrganizedUnitConfigurationList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchOrganizedUnitConfigurationList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleConfigParameterChange (configParameterId) {
    if (this.state.filter.configParameterId !== configParameterId) {
      this.setState({ filter: { ...this.state.filter, configParameterId } })
    }
  }

  handleorganizedUnitComboChange (organizedUnitId) {
    if (this.state.filter.organizedUnitId !== organizedUnitId) {
      this.setState({ filter: { ...this.state.filter, organizedUnitId } })
    }
  }

  search () {
    this.props.actions.fetchOrganizedUnitConfigurationList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        organizedUnitId: null,
        configParameterId: null
      }
    }, () => { this.search() })
  }

  render () {
    const {
      t, organizedUnitConfigurationList, pagesCount, organizedUnitConfigurationsCount, filter,
      combos: { organizedUnitsAllCombo, configParameterAllCombo },
      filter: { page },
      actions: { openOrganizedUnitConfigurationModal, fetchOrganizedUnitConfigurationList, deleteOrganizedUnitConfiguration }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'organizedUnitConfigurationPage' })
    const tKey = 'MASTERS.ORGANIZED_UNIT_CONFIGURATION_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const hasFilters = !!((this.state.filter.configParameterId || this.state.filter.organizedUnitId))

    return (
      <div id='organizedUnitConfigurationMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openOrganizedUnitConfigurationModal()}>
              <i className='iDocIcon-add-plus'></i> {t(`${tKey}ADD`)} {t(`${secMapMasters.title}`)}
            </Button>

          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.configParameterId"
                controlLabel={t(`${tKey}CONFIG_PARAMETER`)}
                placeholder={t(`${tKey}CONFIG_PARAMETER`)}
                valueKey="id"
                labelKey="value"
                options={configParameterAllCombo}
                onInputChange={(value) => this.handleConfigParameterChange(value)}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.organizedUnitId"
                controlLabel={t(`${tKey}OU`)}
                placeholder={t(`${tKey}OU`)}
                valueKey="id"
                labelKey="value"
                options={organizedUnitsAllCombo}
                onInputChange={(value) => this.handleorganizedUnitComboChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.search()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}>
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              { organizedUnitConfigurationList?.length !== 0 &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('documentTypeId') }}>
                        {t(`${tKey}OU`)}
                        <i className={this.getSortIcon('documentTypeId')} />
                      </th>
                      <th onClick={() => { this.changeOrder('organizedUnitConfiguration.code') }}>
                        {t(`${tKey}VALUE`)}
                        <i className={this.getSortIcon('organizedUnitConfiguration.code')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {organizedUnitConfigurationList && organizedUnitConfigurationList.map((organizedUnitConfiguration, idx) => {
                      return (
                        <tr key={idx} className={organizedUnitConfiguration.isDeleted ? 'is-deleted' : ''}>
                          <td>{organizedUnitsAllCombo && organizedUnitsAllCombo.find(x => x.id === organizedUnitConfiguration?.organizedUnitId) && organizedUnitsAllCombo.find(x => x.id === organizedUnitConfiguration?.organizedUnitId).value}</td>
                          <td>{(!organizedUnitConfiguration.configParameter.type.includes('List')) ? organizedUnitConfiguration.value : organizedUnitConfiguration.value.join(',')}</td>
                          <td className='actions'>
                            {!organizedUnitConfiguration.isDeleted && (
                              <div>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn 'onClick={() => openOrganizedUnitConfigurationModal(organizedUnitConfiguration)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deleteOrganizedUnitConfiguration(organizedUnitConfiguration.organizedUnitConfigurationId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            )}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              }
              {(organizedUnitConfigurationList === null || organizedUnitConfigurationList === undefined || organizedUnitConfigurationList.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={organizedUnitConfigurationsCount}
                    onSelectAction={(value) => fetchOrganizedUnitConfigurationList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>

        <OrganizedUnitConfigurationModalPage/>

        <Col sm={12} className="col-row  section-users-body">

        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listDocumentType'
})(OrganizedUnitConfigurationMaster)
